import React from "react";

export function Products(){
    return(
        <div>
            <h1>Produtos</h1>
        </div>
    )
}